"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PartnerApiVehicleTypeLiteAlternative = exports.VehicleAlternativeToPrimaryVehicleType = exports.VehicleTypeToLiteAlternative = exports.VehicleTypesExcludingShuttleAndLite = exports.VehicleTypesExcludingShuttle = exports.VehicleTypeToVehicleImageLink = exports.VehicleModelDescriptions = exports.VehicleTypeDescriptions = exports.VehicleTypesCarryOns = exports.VehicleTypesSuitcases = exports.VehicleTypesCapacity = exports.VehiclePartnerApiTypeToVehicleType = exports.VehicleTypePartnerApiType = exports.VehicleTypes = exports.VehiclePartnerApiTypeNamesExcludingShuttle = exports.VehiclePartnerApiTypeNames = exports.VehiclePartnerApiType = exports.LuxuryVehicleTypes = exports.PartnerApiOnlyVehicleTypes = exports.VehicleTypesWithLiteAlternative = exports.LiteVehicleTypes = exports.VehicleType = void 0;
var VehicleType;
(function (VehicleType) {
    VehicleType[VehicleType["Sedan"] = 0] = "Sedan";
    VehicleType[VehicleType["Mpv"] = 1] = "Mpv";
    VehicleType[VehicleType["Van"] = 2] = "Van";
    VehicleType[VehicleType["LuxurySedan"] = 3] = "LuxurySedan";
    VehicleType[VehicleType["Shuttle"] = 4] = "Shuttle";
    VehicleType[VehicleType["SedanLite"] = 100] = "SedanLite";
    VehicleType[VehicleType["MpvLite"] = 101] = "MpvLite";
    VehicleType[VehicleType["VanLite"] = 102] = "VanLite";
})(VehicleType || (exports.VehicleType = VehicleType = {}));
exports.LiteVehicleTypes = [VehicleType.SedanLite, VehicleType.MpvLite, VehicleType.VanLite];
exports.VehicleTypesWithLiteAlternative = [VehicleType.Sedan, VehicleType.Mpv, VehicleType.Van];
exports.PartnerApiOnlyVehicleTypes = [VehicleType.MpvLite, VehicleType.VanLite];
exports.LuxuryVehicleTypes = [VehicleType.LuxurySedan];
var VehiclePartnerApiType;
(function (VehiclePartnerApiType) {
    VehiclePartnerApiType[VehiclePartnerApiType["sedan"] = 0] = "sedan";
    VehiclePartnerApiType[VehiclePartnerApiType["mpv"] = 1] = "mpv";
    VehiclePartnerApiType[VehiclePartnerApiType["van"] = 2] = "van";
    VehiclePartnerApiType[VehiclePartnerApiType["luxury"] = 3] = "luxury";
    VehiclePartnerApiType[VehiclePartnerApiType["shuttle"] = 4] = "shuttle";
    VehiclePartnerApiType[VehiclePartnerApiType["sedanLite"] = 100] = "sedanLite";
    VehiclePartnerApiType[VehiclePartnerApiType["mpvLite"] = 101] = "mpvLite";
    VehiclePartnerApiType[VehiclePartnerApiType["vanLite"] = 102] = "vanLite";
})(VehiclePartnerApiType || (exports.VehiclePartnerApiType = VehiclePartnerApiType = {}));
exports.VehiclePartnerApiTypeNames = Object.keys(VehiclePartnerApiType).filter((key) => isNaN(Number(key)));
exports.VehiclePartnerApiTypeNamesExcludingShuttle = exports.VehiclePartnerApiTypeNames.filter((vehicle) => vehicle !== "shuttle");
exports.VehicleTypes = Object.keys(VehicleType)
    .filter((key) => !Number.isNaN(Number(key)))
    .map((i) => Number(i));
exports.VehicleTypePartnerApiType = {
    [VehicleType.Sedan]: "sedan",
    [VehicleType.Mpv]: "mpv",
    [VehicleType.Van]: "van",
    [VehicleType.LuxurySedan]: "luxury",
    [VehicleType.Shuttle]: "shuttle",
    [VehicleType.SedanLite]: "sedanLite",
    [VehicleType.MpvLite]: "mpvLite",
    [VehicleType.VanLite]: "vanLite",
};
exports.VehiclePartnerApiTypeToVehicleType = {
    ["sedan"]: VehicleType.Sedan,
    ["mpv"]: VehicleType.Mpv,
    ["van"]: VehicleType.Van,
    ["luxury"]: VehicleType.LuxurySedan,
    ["shuttle"]: VehicleType.Shuttle,
    ["sedanLite"]: VehicleType.SedanLite,
    ["mpvLite"]: VehicleType.MpvLite,
    ["vanLite"]: VehicleType.VanLite,
};
exports.VehicleTypesCapacity = {
    [VehicleType.Sedan]: 3,
    [VehicleType.LuxurySedan]: 2,
    [VehicleType.Mpv]: 4,
    [VehicleType.Van]: 7,
    [VehicleType.Shuttle]: 10,
    [VehicleType.SedanLite]: 3,
    [VehicleType.MpvLite]: 4,
    [VehicleType.VanLite]: 7,
};
exports.VehicleTypesSuitcases = {
    [VehicleType.Sedan]: 3,
    [VehicleType.LuxurySedan]: 2,
    [VehicleType.Mpv]: 4,
    [VehicleType.Van]: 7,
    [VehicleType.Shuttle]: 10,
    [VehicleType.SedanLite]: 3,
    [VehicleType.MpvLite]: 4,
    [VehicleType.VanLite]: 7,
};
exports.VehicleTypesCarryOns = {
    [VehicleType.Sedan]: 3,
    [VehicleType.LuxurySedan]: 2,
    [VehicleType.Mpv]: 4,
    [VehicleType.Van]: 7,
    [VehicleType.Shuttle]: 10,
    [VehicleType.SedanLite]: 3,
    [VehicleType.MpvLite]: 4,
    [VehicleType.VanLite]: 7,
};
exports.VehicleTypeDescriptions = {
    [VehicleType.Sedan]: "Sedan comparable to a Volkswagen Passat, up to 3 passengers with luggage.",
    [VehicleType.LuxurySedan]: "Luxury sedan comparable to a Mercedes-Benz E-Class, up to 2 passengers with luggage.",
    [VehicleType.Mpv]: "Compact MPV comparable to a Volkswagen Touran, up to 4 passengers with luggage.",
    [VehicleType.Van]: "Van comparable to a VW Transporter, up to 7 passengers with luggage.",
    [VehicleType.Shuttle]: "Shuttle comparable to a Mercedes-Benz Vito, up to 10 passengers with luggage.",
    [VehicleType.SedanLite]: "Sedan comparable to a Volkswagen Passat, up to 3 passengers with luggage.",
    [VehicleType.MpvLite]: "Compact MPV comparable to a Volkswagen Touran, up to 4 passengers with luggage.",
    [VehicleType.VanLite]: "Van comparable to a VW Transporter, up to 7 passengers with luggage.",
};
exports.VehicleModelDescriptions = {
    [VehicleType.Sedan]: "VW Passat or similar",
    [VehicleType.LuxurySedan]: "Mercedes-Benz E-Class or similar",
    [VehicleType.Mpv]: "VW Touran or similar",
    [VehicleType.Van]: "VW Transporter or similar",
    [VehicleType.Shuttle]: "Mercedes-Benz Vito or similar",
    [VehicleType.SedanLite]: "VW Passat or similar",
    [VehicleType.MpvLite]: "VW Touran or similar",
    [VehicleType.VanLite]: "VW Transporter or similar",
};
exports.VehicleTypeToVehicleImageLink = {
    [VehicleType.Sedan]: "https://images.daytrip.com/site/sedan.png",
    [VehicleType.SedanLite]: "https://images.daytrip.com/site/sedan.png",
    [VehicleType.Mpv]: "https://images.daytrip.com/site/mpv.png",
    [VehicleType.Van]: "https://images.daytrip.com/site/van-vw.png",
    [VehicleType.LuxurySedan]: "https://images.daytrip.com/site/luxury-sedan.png",
    [VehicleType.Shuttle]: "https://images.daytrip.com/site/shuttle.png",
    [VehicleType.MpvLite]: "https://images.daytrip.com/site/mpv.png",
    [VehicleType.VanLite]: "https://images.daytrip.com/site/van.png",
};
exports.VehicleTypesExcludingShuttle = exports.VehicleTypes.filter((type) => type !== VehicleType.Shuttle);
exports.VehicleTypesExcludingShuttleAndLite = exports.VehicleTypesExcludingShuttle.filter((type) => !exports.LiteVehicleTypes.includes(type));
exports.VehicleTypeToLiteAlternative = {
    [VehicleType.Sedan]: VehicleType.SedanLite,
    [VehicleType.Mpv]: VehicleType.MpvLite,
    [VehicleType.Van]: VehicleType.VanLite,
};
exports.VehicleAlternativeToPrimaryVehicleType = {
    [VehicleType.SedanLite]: VehicleType.Sedan,
    [VehicleType.MpvLite]: VehicleType.Mpv,
    [VehicleType.VanLite]: VehicleType.Van,
};
exports.PartnerApiVehicleTypeLiteAlternative = {
    ["sedan"]: "sedanLite",
    ["mpv"]: "mpvLite",
    ["van"]: "vanLite",
};
//# sourceMappingURL=VehicleType.js.map